import React, { forwardRef } from "react";
import { MenuItem } from "@material-ui/core";

export default forwardRef((props, ref) => (
  <MenuItem value="" component="div" ref={ref} {...props}>
    <ul style={{ listStyle: "none", paddingInlineStart: "0px" }}>
      <li>-- clear selection --</li>
    </ul>
  </MenuItem>
));

